// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"61328beb","977":"dab9c30c"}[chunkId] + ".chunk.js";
};